import api from "@api";
import { getSearchResultOnRow } from "@Ekcore/util";
import router from "@/router";


export default {
    state: {
        users: [],
        userDto: {},
        userCols: [
            {
                label: "اسم المستخدم",
                field: "userName",
            },
            {
                label: "الاسم والكنية  ",
                field: "name",
            },
            {
                label: " البريد الإلكتروني",
                field: "email",
            },
            {
                label: " رقم الموبايل ",
                field: "phoneNumber",
            },
            {
                label: "  تاريخ الإضافة ",
                field: "dateCreated",
            },
            {
                label: "التفاصيل",
                field: "details",
            },
        ],
    },
    getters:{
        userList({ users }, getter , { filter }) {
            return users.filter(el => {
                return getSearchResultOnRow(filter, el);
            });
        }
    },
    mutations: {
        SET_USER(state, payload) {
            state.users = payload;
        },
        Add_Users(state, payload) {
            state.users.unshift(payload);
        },
        Update_Users(state, payload) {
            state.userDto = payload
        },
        Get_Details_User(state, payload) {
            state.userDto = payload
        },
        Delete_User(state, id) {
            state.users.splice(
                state.users.findIndex((item) => item.id == id),
                1
            );
        },
        Delete_Users(state, ids) {
            state.users = state.users.filter(
                (el) => !ids.includes(el.id)
            ); 
        },
    },
    actions: {
        getAllUsers({ commit }) {
            api.get("User/GetAll", ({ data }) => {
                commit("SET_USER", data);
            });
        },
        addUser({ commit }, payload) {
            api.post(
                "User/Add",
                payload,
                ({ data }) => {
                    commit("Add_Users", data);
                },
                {
                    success: "تم إضافة المستخدم بنجاح",
                    error: "فشل إضافة المستخدم",
                }
            );
        },
        getByIdUser({ commit }, id) {
            api.get(`User/GetById?UserId=${id}`, ({ data }) => {
                commit("Get_Details_User", data);
            });
        },
        updateUser({ commit }, payload) {
            api.post(
                "User/Modify",
                payload,
                ({ data }) => {
                    commit("Update_Users", data);
                    router.go(-1)
                },
                {
                    success: "تم تعديل المستخدم بنجاح",
                    error: "فشل تعديل المستخدم",
                }
            );
        },
        deleteUser({ commit }, id) {
            api.delete(
                `User/Delete?id=${id}`,
                () => {
                    commit("Delete_User", id);
                    router.go(-1)
                },
                {
                    confirm: " هل تريد بالتأكيد حذف المستدم",
                    success: "تم حذف المستخدم بنجاح",
                    error: "فشل حذف المستدم ..يرجى اعادة المحاولة ",
                }
            );
        },
        deleteUsers({ commit }, ids) {
            api.delete(
                "User/DeleteRange",
                () => {
                    commit("Delete_Users", ids);
                },
                {
                    confirm: " ?هل تريد بالتأكيد حذف المستخدمين المحددة",
                    success: "تم حذف المستخدمين بنجاح",
                    error: "فشل الحذف ..يرجى اعادة المحاولة ",
                },
                ids
            );
        },
    }
};
